import { render, staticRenderFns } from "./FeishuCallback.vue?vue&type=template&id=a919250a&scoped=true"
import script from "./FeishuCallback.vue?vue&type=script&lang=js"
export * from "./FeishuCallback.vue?vue&type=script&lang=js"
import style0 from "./FeishuCallback.vue?vue&type=style&index=0&id=a919250a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a919250a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a919250a')) {
      api.createRecord('a919250a', component.options)
    } else {
      api.reload('a919250a', component.options)
    }
    module.hot.accept("./FeishuCallback.vue?vue&type=template&id=a919250a&scoped=true", function () {
      api.rerender('a919250a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/FeishuCallback.vue"
export default component.exports